export const BULK_REFUNDS_REQUESTING = 'bulkRefunds/REQUESTING';
export const BULK_REFUNDS_SUCCESS = 'bulkRefunds/SUCCESS';
export const BULK_REFUNDS_ERROR = 'bulkRefunds/ERROR';

export const UPLOAD_TRANSACTION_LIST_REQUESTING =
	'uploadTransactionList/REQUESTING';
export const UPLOAD_TRANSACTION_LIST_SUCCESS = 'uploadTransactionList/SUCCESS';
export const UPLOAD_TRANSACTION_LIST_ERROR = 'uploadTransactionList/ERROR';
